<template>
  <span class="icon-text flex flex-middle gap-s" :class="wrapperClass">
    <icon
      v-if="icon && finalIconPosition === 'start'"
      :theme="iconTheme"
      :icon="icon"
      :size="iconSize"
      class="icon-text__icon"></icon>
    <span class="icon-text__text" :class="textClass">
      <slot>{{ text ? translate(text) : "" }}</slot>
    </span>
    <icon
      v-if="icon && finalIconPosition === 'end'"
      :icon="icon"
      :size="iconSize"
      :theme="iconTheme"
      class="icon-text__icon"></icon>
  </span>
</template>
<script>
import IconTextMixin from "@/client/extensions/mixins/baseComponents/html/iconText.js";

export default {
  mixins: [IconTextMixin],
  props: {
    theme: {
      type: [String, Boolean],
      default: false,
    },
    iconTheme: {
      type: [String, Boolean],
      default: false,
    },
  },
  computed: {
    finalIconPosition() {
      if (this.iconPosition === "end") {
        return "end";
      }

      return "start";
    },
    wrapperClass() {
      let result = [];
      result.push("gap-" + this.gap);
      result.push("flex-" + this.iconAlign);
      if (typeof this.theme === "string") {
        result.push(`c-${this.theme}`);
      }
      return result;
    },
  },
};
</script>
